import frame1Svg from '@listening/assets/astro/images/Frame-1.svg';
import frame3Svg from '@listening/assets/astro/images/Frame-3.svg';
import frame4Svg from '@listening/assets/astro/images/Frame-4.svg';
import frame1362789761Png from '@listening/assets/astro/images/Frame-1362789761.png';

import { CtaButton } from '@/components/astro/cta-button/cta-button';

export function SoundsNaturalEvenAtSpeedSection() {
  return (
    <section className='flex flex-col items-center justify-center gap-8 px-5 pt-18 pb-9 sm:gap-14 sm:px-14 lg:gap-18 lg:px-18'>
      <div className='flex max-w-[1296px] flex-col-reverse items-center gap-8 sm:gap-18 lg:flex-row'>
        <img
          alt='App Frame'
          className='block max-h-[500px] min-w-[250px] flex-[2_auto] grow object-scale-down md:max-h-[auto]'
          loading='eager'
          src={frame1362789761Png}
        />
        <div className='flex w-full max-w-[612px] flex-[3_auto] grow flex-col gap-8'>
          <div className='flex flex-col items-start gap-4'>
            <div className='flex items-center justify-center gap-3 rounded-full bg-azure-455/10 px-4 py-[5px]'>
              <div className='rotate-90 text-[20px] leading-[27px] font-[500]'>
                👆
              </div>
              <div className='text-[12px] leading-[16px] font-[600] text-neutral-945 sm:text-[16px] sm:leading-[21.6px]'>
                SPEED
              </div>
            </div>
            <div className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[44px] lg:leading-[47px]'>
              “It sounds <span className='text-azure-595'>so natural</span>,
              even at 2x speed”
            </div>
          </div>
          <div className='flex flex-[2_auto] flex-col items-start gap-8 self-stretch sm:gap-6 lg:self-auto'>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={frame3Svg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-840 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                Effortlessly zip through easier content at speeds up to 4x!
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={frame4Svg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-840 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                Take your time with more challenging material by slowing down to
                1x or even 0.5x.
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={frame1Svg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-840 sm:text-[24px] sm:leading-[32px] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                The power to tailor your listening experience is right at your
                fingertips!
              </div>
            </div>
          </div>
        </div>
      </div>
      <CtaButton className='inline-block h-auto cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[18px] leading-[24px] font-[500] text-neutral-50 no-underline sm:px-6 sm:text-[28px] sm:leading-[37px] lg:px-16 lg:py-5' />
    </section>
  );
}
